/**
 * Versão leve de uma imagem, para telas que só precisam exibir.
 *
 * POR QUE. O node guarda em `media_url` o arquivo que vai para a Meta — medido
 * em 14/09, 1.533 KB de média por arte e 2 MB nas maiores. O canvas do flow
 * desenha uma miniatura de 100px com esse arquivo: um flow com 20 imagens baixa
 * ~40 MB para mostrar 20 selos. O upload gera junto um WebP de 960px
 * (`{nome}_preview.webp`, mesmo diretório) que resolve isso.
 *
 * O nome é derivado em vez de vir do banco porque o node guarda só a URL —
 * fazer o backend devolver o preview de cada node exigiria uma consulta por
 * node no carregamento do flow.
 *
 * SEMPRE use junto de `aoFalharVersaoLeve` no onError da <img>: arte antiga,
 * importada ou recém-recortada pode não ter preview gerado, e aí o certo é
 * cair no arquivo original em vez de mostrar imagem quebrada.
 */
export const versaoLeve = (url?: string | null): string | undefined => {
    if (!url) return undefined;
    if (!/^https?:\/\//i.test(url)) return url;
    if (/_preview\.webp$/i.test(url) || /_thumb\.webp$/i.test(url)) return url;
    if (!/\.(jpe?g|png|webp|gif|bmp)(\?.*)?$/i.test(url)) return url;

    const [semQuery, query] = url.split('?');
    const base = semQuery.replace(/\.[^./]+$/, '');
    return `${base}_preview.webp${query ? `?${query}` : ''}`;
};

/** onError da <img>: volta para o arquivo original quando não há preview. */
export const aoFalharVersaoLeve = (
    e: React.SyntheticEvent<HTMLImageElement>,
    original?: string | null
) => {
    const img = e.currentTarget;
    if (!original || img.src === original) return;
    img.src = original;
};
